export const TRANSLATIONS_NAMESPACE = 'app-installer-client';
export const getPathToMessages = (translationsStaticUrl, langCode) => `${translationsStaticUrl}assets/locale/messages_${langCode}.json`;
export const addResourceI18n = (i18n, messages) => {
  i18n.addResourceBundle(i18n.language, TRANSLATIONS_NAMESPACE, messages);
};
export const getI18nHasInstallerResource = i18n => i18n.hasResourceBundle(i18n.language, TRANSLATIONS_NAMESPACE);
//# sourceMappingURL=i18nResources.js.map